module.exports = __webpack_public_path__ + "fonts/little-days-alt.8c755e5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/peekaboo/fonts/little-days-alt.woff
// module id = 395
// module chunks = 0